import { Checkbox } from '@gov-design-system-ce/react-form';
import type { DokumentyDokumentDto } from '@gov-nx/api';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { Button, Space } from '@gov-nx/ui/web';
import { toDateTimeReadable } from '@gov-nx/utils/common';

interface DocumentTableRowProps {
	document: DokumentyDokumentDto;
}

export const TableRow = ({ document }: DocumentTableRowProps) => {
	const { myFilesDownload, controls, code, formDefinition } =
		useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	if (!document.dokumentId) {
		return null;
	}

	const createdAt =
		document.datumVytvoreni && toDateTimeReadable(document.datumVytvoreni);

	return (
		<li
			key={document.dokumentId}
			className="flex flex-col gap-(--spacing-s) relative p-(--templates-margin-l) border-b border-(--border-subtlest) [ last-of-type:border-b-0 ] [ md:mx-0 ]">
			<div className="flex flex-col gap-(--spacing-xs) [ md:flex-row md:gap-(--spacing-m) ]">
				<Button
					aria-label={tsn('akce.stahnout')}
					color="primary"
					type="link"
					size="s"
					isDisabled={
						myFilesDownload.isDownloading(document.dokumentId) ||
						!myFilesDownload.hasFileToDownload(document)
					}
					isLoading={myFilesDownload.isDownloading(document.dokumentId)}
					onClick={() => {
						document.dokumentId &&
							document.soubory?.[0]?.souborId &&
							myFilesDownload.downloadDocument({
								documentId: document.dokumentId,
								souborId: document.soubory?.[0]?.souborId,
							});
					}}
					className="mr-auto! text-body-s-bold! text-(--text-primary-color) max-w-[75%]!">
					<div className="text-wrap break-all text-left mr-8">
						{document.soubory?.[0]?.nazev || document.nazev}
					</div>
				</Button>
				<div className="text-body-s text-(--text-secondary) min-w-fit">
					{createdAt}
				</div>
				<div className="absolute top-(--templates-margin-l) right-(--templates-margin-l) w-(--height-m-nudge) h-(--height-m-nudge) [ md:relative md:top-auto md:right-auto ]">
					<div className="relative -mt-[10px]!">
						<Checkbox
							name={`selection.${document.dokumentId}`}
							size="m"
							isDisabled={controls.processLoading}
							hasNoLabel={true}
							aria-label={tsn('vyber.oznacit')}
							onChange={(e) => {
								formDefinition.formMethods.setValue(
									`selection.${document.dokumentId}`,
									e.target.checked
										? {
												checked: true,
												souborId: document.soubory?.[0]?.souborId,
											}
										: undefined
								);
							}}
							isChecked={
								formDefinition.formMethods.getValues(
									`selection.${document.dokumentId}`
								)?.checked
							}
						/>
					</div>
				</div>
			</div>

			<div className="mt-(--spacing-xs) inline text-body-s text-(--text-secondary) max-w-full">
				<span>{tsn('data.zdroj-souboru')}: </span>
				<strong className="mr-2!">{tsn(`data.zdroj.${document.zdroj}`)}</strong>
				<Space />
				{document.nazev && (
					<span className="block break-all text-normal max-w-full text-(--text-primary-color) [ md:inline ]">
						{document.nazev}
					</span>
				)}
			</div>
		</li>
	);
};
